module.exports = __webpack_public_path__ + "fonts/Formular-Medium.24b26c4.woff2";